@if (subscription) {
  <div class="row align-items-stretch">
    <div class="col-12 col-lg-6 mb-3">
      @if (!subscription.isOneTrial && !subscription.isOne) {
        <app-subscription-details-card
        [subscription]="subscription"></app-subscription-details-card>
      }
      @if (subscription.isOneTrial || subscription.isOne) {
        <app-subscription-one-details-card
        [subscription]="subscription"></app-subscription-one-details-card>
      }
    </div>
    @if (subscription.isOneTrial) {
      <div class="col-12 col-md-6 mb-3">
        <app-subscription-trial-details [subscription]="subscription"></app-subscription-trial-details>
      </div>
    }
    @if (subscription.isOne) {
      <div class="col-12 col-md-6 mb-3">
        <app-subscription-concurrent-user [subscription]="subscription"></app-subscription-concurrent-user>
      </div>
    }
    @if (subscription.isOne && subscription.sla_product) {
      <div class="col-12 col-md-6 mb-3">
        <app-subscription-sla [subscription]="subscription"></app-subscription-sla>
      </div>
    }
    @if (subscription.isOne && subscription.pcCredit > 0) {
      <div class="col-12 col-md-6 mb-3">
        <app-subscription-credits [credit]="subscription.pcCredit"></app-subscription-credits>
      </div>
    }
    @if (subscription.isOne && subscription.hasActivePhoneNumber) {
      <div class="col-12 col-md-6 mb-3">
        <app-fallback-number-card [subscription]="subscription"></app-fallback-number-card>
      </div>
    }
    <div class="col-12 col-md-6 mb-3">
      <app-subscription-support-type-card [subscription]="subscription"></app-subscription-support-type-card>
    </div>
    @if (subscription.isOneTrial) {
      <div class="col-12 col-md-6 mb-3">
        <app-subscription-trial-card></app-subscription-trial-card>
      </div>
    }
    @if (subscription.isOneTrial) {
      <div class="col-12 col-md-6 mb-3">
        <app-subscription-trial-ai-tariff-infos></app-subscription-trial-ai-tariff-infos>
      </div>
    }
    @if (subscription?.license_exceeded_subscription_active !== undefined) {
      <div class="col-12 col-md-6 mb-3">
          <app-subscription-license-exceeded-card [subscription]="subscription"></app-subscription-license-exceeded-card>
      </div>
    }
    @if (!subscription.isOneTrial && !isCSP) {
      <div class="col-12 col-md-6 mb-3">
        <app-subscription-availability-card [subscription]="subscription"></app-subscription-availability-card>
      </div>
    }
    @if (hasInvoiceFormatSelector) {
      <div class="col-12 col-md-6 mb-3">
        <app-subscription-invoice-type-card [subscription]="subscription"></app-subscription-invoice-type-card>
      </div>
    }
    @if (subscription.isOne && isAdmin) {
      <div class="col-12 col-md-6 mb-3">
        <app-subscription-reference-card [subscription]="subscription"></app-subscription-reference-card>
      </div>
    }
  </div>
}

@if (subscription) {
  <app-subscription-one-cancel-button
  [subscription]="subscription"></app-subscription-one-cancel-button>
}
